export type FileLike =
  | File
  | { name?: string; size?: number; base64?: string; type?: string; lastModified?: number }
  | null
  | undefined;

export function isFileLike(f: unknown): f is Exclude<FileLike, null | undefined> {
  const anyF = f as any;
  return (
    !!anyF &&
    typeof anyF === "object" &&
    typeof anyF.name === "string" &&
    (typeof anyF.size === "number" || typeof anyF.base64 === "string")
  );
}

export function getExtFromFileLike(f: FileLike): string {
  const anyF = f as any;
  const mime = String(anyF?.type || "")
    .split("/")
    .pop() || "";
  const fromName =
    typeof anyF?.name === "string" && anyF.name.includes(".")
      ? anyF.name.split(".").pop()
      : "";

  const ext = String(fromName || mime || "pdf")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

  return ext === "octet-stream" ? "pdf" : ext || "pdf";
}

export function base64ToBytes(b64: string): { mime: string; bytes: Uint8Array } {
  let mime = "";
  let raw = b64 || "";
  const m = /^data:([^;]+);base64,(.*)$/i.exec(String(b64 || ""));
  if (m) {
    mime = m[1] || "";
    raw = m[2] || "";
  }
  const binStr = atob(raw);
  const len = binStr.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binStr.charCodeAt(i);
  return { mime, bytes };
}

export async function toFileNamed(
  src: FileLike,
  desiredName: string,
  mimeFallback = "application/pdf"
): Promise<File | null> {
  if (src instanceof File) {
    if (src.name === desiredName) return src;
    return new File([src], desiredName, {
      type: src.type || mimeFallback,
      lastModified: src.lastModified || Date.now(),
    });
  }

  const anySrc = src as any;
  if (anySrc && typeof anySrc.base64 === "string") {
    const { mime, bytes } = base64ToBytes(anySrc.base64);
    return new File([bytes], desiredName, { type: mime || mimeFallback });
  }

  return null;
}

